import React, { useState } from "react";
import { useAuth } from "../../../contexts/AuthContext";
import TextField from "../../../components/Input/TextField";
import { toast } from "react-toastify";
import { HiXCircle } from "react-icons/hi";

const AddUser = ({ setAddUser }) => {
  const { register } = useAuth();
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    passwordAgain: "",
    isAdmin: false,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.passwordAgain) {
      toast.error("Şifreler uyuşmuyor!");
      return;
    }

    setLoading(true);
    const res = await register(formData);
    setLoading(false);

    if (res?.status === "failed") {
      toast.error("Kayıt işlemi başarısız: " + res.message);
    } else if (res?.status === "success") {
      toast.success("Kayıt başarılı!");
      setAddUser(false);
    } else {
      toast.error("Bir Hata Oluştu");
    }
  };

  return (
    <dialog open className="modal">
      <div className="modal-box bg-gray-800 text-white">
        <HiXCircle
          className="text-3xl justify-self-end cursor-pointer hover:text-red-600"
          onClick={() => setAddUser(false)}
        />
        <h1 className="mb-8 text-2xl flex mx-auto w-max font-semibold">
          Kullanıcı Oluştur
        </h1>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-2 p-4 rounded-xl w-96 m-auto"
        >
          <TextField
            type="text"
            name="username"
            placeholder="Kullanıcı Adı"
            value={formData.username}
            onChange={handleChange}
            required
          />
          <TextField
            type="email"
            name="email"
            placeholder="E-posta"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <TextField
            type="password"
            name="password"
            placeholder="Parola"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <TextField
            type="password"
            name="passwordAgain"
            placeholder="Parola Tekrar"
            value={formData.passwordAgain}
            onChange={handleChange}
            required
          />

          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input
              className="checkbox rounded"
              type="checkbox"
              name="isAdmin"
              checked={formData.isAdmin}
              onChange={handleChange}
            />
            Admin olarak kaydet
          </label>

          <button
            type="submit"
            className="bg-blue-500 text-white p-2 rounded mt-12"
            disabled={loading}
          >
            {loading ? "Kayıt yapılıyor..." : "Kaydet"}
          </button>
        </form>
      </div>
      <div
        className="modal-backdrop cursor-pointer"
        onClick={() => setAddUser(false)}
      ></div>
    </dialog>
  );
};

export default AddUser;